// extracted by mini-css-extract-plugin
export default {"cont":"index_cont__+ICc0","big_title":"index_big_title__O8mCe","media":"index_media__eW4bI"};